import { useRecoilValue } from "recoil";
import { WideState } from "../../recoil/wide";
import MobileTournamentList from "./mobile";
import PcTournamentList from "./pc";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PubOwnerRole, PubOwnerDomain } from "../../api/cafe";
import { pubState } from "../../recoil/pub.atom";

const TournamentList = () => {
  const isWide = useRecoilValue(WideState);
  const pub = useRecoilValue(pubState);
  const navigate = useNavigate();

  useEffect(() => {
    if (!pub) {
      navigate("/");
      return;
    }
    if (pub.role === PubOwnerRole.OWNER || pub.domains.length === 0) return;
    if (!pub?.domains.includes(PubOwnerDomain.TOURNAMENT)) {
      navigate("/");
      alert("해당 페이지 접근 권한이 없습니다. ");
      return;
    }
  }, [navigate, pub]);

  if (!isWide) {
    return <MobileTournamentList />;
  }

  return <PcTournamentList />;
};

export default TournamentList;
